import Link from "next/link";
export default function IntegrationCards({ data }) {
  const Card = ({ data }) => {
    return (
      <Link
        href={data.href}
        prefetch={false}
        id={data.id}
        className="hover:box-shadow"
      >
        <figure dangerouslySetInnerHTML={{ __html: data.icon }} />
        <div>
          <h3 className={data.hasOwnProperty("desc") ? `` : `mt-1`}>
            {data.title}
          </h3>
          {data.hasOwnProperty("desc") && <p>{data.desc}</p>}
        </div>
      </Link>
    );
  };
  return (
    <div className="card--default card--showcase has-three-col has-gutter-md jc-fs c-padding top-integrations">
      {data.map((item, index) => {
        return <Card key={index} data={item} />;
      })}
    </div>
  );
}
